import request from '@/utils/axios.js'

// 查询核酸检测信息
export function queryNucleicAcidTestVo (data) {
  return request({
    url: '/qdt-nfc/mobileAPI/qdt/healthcode/queryNucleicAcidTestVo',
    method: 'post',
    data: data
  })
}

// 行程核验
export function queryTripInfo (data) {
  return request({
    url: '/qdt-nfc/mobileAPI/qdt/healthcode/queryTripInfo',
    method: 'post',
    data: data
  })
}

// 行程核验短信发送
export function sendTripVerifySmsCode (data) {
  return request({
    url: '/qdt-nfc/mobileAPI/qdt/healthcode/sendTripVerifySmsCode',
    method: 'post',
    data: data
  })
}

// 接口
export function getRealInfo (data) {
  return request({
    url: '/usercenter/mobileAPI/user/token/convert',
    method: 'get',
    data: data
  })
}
